import React from 'react';

const TableSkeleton = () => {
  return (
    <div className="overflow-x-auto border rounded-lg">
      <table className="min-w-full text-sm text-left text-gray-500">
        <thead className="text-sm font-normal font-inter text-[#4A4D4F]">
          <tr>
            <th className="px-6 py-4">Generated leads</th>
            <th className="px-6 py-4">Daily budget</th>
            <th className="px-6 py-4">Results</th>
            <th className="px-6 py-4">Cost per result</th>
            <th className="px-6 py-4">Total spent</th>
            <th className="px-6 py-4">Cost per click</th>
            <th className="px-6 py-4">No. of creatives</th>
            <th className="px-6 py-4">Avg. hook rate</th>
            <th className="px-6 py-4">Avg. hold rate</th>
          </tr>
        </thead>
        <tbody>
          {/* Skeleton Rows */}
          {Array.from({ length: 5 }).map((_, index) => (
            <tr key={index} className="border-t bg-white hover:bg-gray-50">
              {/* Generated Leads */}
              <td className="px-6 py-4 flex items-center space-x-3">
                <div className="w-10 h-10 bg-gray-300 rounded-full animate-pulse"></div>
                <div>
                  <div className="h-4 bg-gray-300 rounded w-24 mb-2 animate-pulse"></div>
                  <div className="h-3 bg-gray-200 rounded w-32 animate-pulse"></div>
                </div>
              </td>
              {/* Daily Budget */}
              <td className="px-6 py-4">
                <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
              </td>
              {/* Results */}
              <td className="px-6 py-4">
                <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
              </td>
              {/* Cost per Result */}
              <td className="px-6 py-4">
                <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
              </td>
              {/* Total Spent */}
              <td className="px-6 py-4">
                <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
              </td>
              {/* Cost per Click */}
              <td className="px-6 py-4">
                <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
              </td>
              {/* No. of Creatives */}
              <td className="px-6 py-4">
                <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
              </td>
              {/* Avg. Hook Rate */}
              <td className="px-6 py-4">
                <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
              </td>
              {/* Avg. Hold Rate */}
              <td className="px-6 py-4">
                <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;